var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18990",
    "data-name": "Rectangle 18990",
    width: 30,
    height: 30,
    rx: 6,
    transform: "translate(55 388)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High_Priority",
    "data-name": "High Priority",
    transform: "translate(-55 -388)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1",
    transform: "translate(55.001 388.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10272",
    "data-name": "Group 10272",
    transform: "translate(0.829 29.169) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43661",
    "data-name": "Path 43661",
    d: "M1.8,28.34a1.8,1.8,0,0,1-1.431-2.9L9,14.171.372,2.9A1.8,1.8,0,1,1,3.235.709l9.472,12.365a1.8,1.8,0,0,1,0,2.192L3.235,27.632A1.794,1.794,0,0,1,1.8,28.34Z",
    fill: "#ff8300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43662",
    "data-name": "Path 43662",
    d: "M10.264,28.34a1.78,1.78,0,0,1-1.1-.374,1.8,1.8,0,0,1-.334-2.527l8.629-11.269L8.834,2.9A1.8,1.8,0,0,1,11.695.709l9.472,12.365a1.8,1.8,0,0,1,0,2.192L11.695,27.632a1.794,1.794,0,0,1-1.431.708Z",
    fill: "#ff8300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43663",
    "data-name": "Path 43663",
    d: "M18.726,28.34a1.78,1.78,0,0,1-1.1-.374,1.8,1.8,0,0,1-.334-2.527l8.629-11.269L17.294,2.9A1.8,1.8,0,1,1,20.155.709l9.472,12.365a1.8,1.8,0,0,1,0,2.192L20.155,27.632a1.794,1.794,0,0,1-1.431.708Z",
    fill: "#ff8300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriority);
export default __webpack_public_path__ + "static/media/highPriority.040c4cc55ae1d13a25aa5981024927dd.svg";
export { ForwardRef as ReactComponent };